"use client"

import { Suspense } from "react"
import { FindConsultantHero } from "@/components/organisms/ConsultantHero"
import { ProfileListSection } from "@/components/organisms/ProfileList"
import { FeaturedConsultantsSection } from "@/components/organisms/ProfileList/featured"
import { SimilarProductsSectionSkeleton } from "@/components/templates/Products/similar-products"
import { BannerSection } from "@/components/organisms/ConsultantHero/banner-section"
import { useConsultantSearch } from "@/hooks/useConsultantSearch"
import { ReactQueryProvider } from "@/contexts/QueryProvider"

const ConsultantsClientPage = ({ translations }: { translations: Record<string, any> }) => {
  const {
    consultants,
    totalPages,
    currentPage,
    filters,
    executeSearch,
    isLoading,
    hasActiveFilters,
  } = useConsultantSearch()

  return (
    <>
      <FindConsultantHero onSubmit={executeSearch} defaultFilters={filters} translations={translations} />
      <BannerSection translations={translations.consultants.banner} />
      {!hasActiveFilters && isLoading ? (
        <SimilarProductsSectionSkeleton />
      ) : !hasActiveFilters && consultants.length > 3 ? (
        <Suspense fallback={<SimilarProductsSectionSkeleton />}>
          <FeaturedConsultantsSection consultants={consultants.slice(0, 20)} translations={translations.consultants} />
        </Suspense>
      ) : null}

      <ProfileListSection consultants={consultants} totalPages={totalPages} currentPage={currentPage} translations={translations} />
    </>
  )
}

export const FindConsultantsPage = ({ translations }: { translations: Record<string, any> }) => (
  <ReactQueryProvider>
    <ConsultantsClientPage translations={translations} />
  </ReactQueryProvider>
)
